import React from "react";
import { Transition } from "react-transition-group";
import styled from "@emotion/styled/macro";

export const TRANSITION_DURATION = 300;

const outTranslation = "translateY(100%)";

const defaultStyle = {
  transition: `all ${TRANSITION_DURATION}ms ease-in-out`,
  opacity: 0,
  transform: outTranslation
};

const transitionStyles = {
  entering: {
    opacity: 1,
    transform: "translateY(0%)"
  },
  entered: { opacity: 1, transform: "translateY(0%)" },
  exiting: { opacity: 0, transform: outTranslation },
  exited: { opacity: 0, transform: outTranslation }
};

const Root = styled("div")`
  background: #edf0f6;
  border: 1px solid #222222;
  border-radius: 10px;
  box-shadow: 0 2px 10px 5px rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

export default function DialogRoot({ onClick, isOpen, ...rest }: any) {
  return (
    <Transition in={isOpen} timeout={TRANSITION_DURATION} appear>
      {(state: "entering" | "entered" | "exiting" | "exited") => (
        <Root
          {...rest}
          style={{
            ...defaultStyle,
            ...transitionStyles[state]
          }}
          onClick={
            onClick ||
            (e => {
              e.stopPropagation();
            })
          }
        />
      )}
    </Transition>
  );
}
